import { RootState } from "../../store";

export const selectLearningHistory = (state: RootState) => state.learningHistory;